import { render, staticRenderFns } from "./khInfo.vue?vue&type=template&id=c97517ae&scoped=true&"
import script from "./khInfo.vue?vue&type=script&lang=js&"
export * from "./khInfo.vue?vue&type=script&lang=js&"
import style0 from "./khInfo.vue?vue&type=style&index=0&id=c97517ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97517ae",
  null
  
)

export default component.exports